export interface ClientConfig {
  REACT_APP_API_URL: string;
  REACT_APP_BASE_URL: string;
  REACT_APP_CUSTOM_APR?: string;
  REACT_APP_CW_ERROR_LEVEL?: string;
  REACT_APP_CW_KEY?: string;
  REACT_APP_CW_MOCK?: string;
  REACT_APP_CW_SHOW_ERRORS?: string;
  REACT_APP_CW_URL?: string;
}

let config: ClientConfig | undefined;

/**
 * Creates or returns the runtime configuration settings
 * for the client
 */
const getConfig = (): ClientConfig => {
  if (config) {
    return config;
  }
  const env: any = (process as any).env;

  config = {
    REACT_APP_API_URL: env.REACT_APP_API_URL || undefined,
    REACT_APP_BASE_URL: env.REACT_APP_BASE_URL || undefined,
    REACT_APP_CUSTOM_APR: env.REACT_APP_CUSTOM_APR || undefined,
    REACT_APP_CW_ERROR_LEVEL: env.REACT_APP_CW_ERROR_LEVEL || undefined,
    REACT_APP_CW_KEY: env.REACT_APP_CW_KEY || undefined,
    REACT_APP_CW_MOCK: env.REACT_APP_CW_MOCK || undefined,
    REACT_APP_CW_SHOW_ERRORS: env.REACT_APP_CW_SHOW_ERRORS || undefined,
    REACT_APP_CW_URL: env.REACT_APP_CW_URL || undefined,
  };

  return config;
};

export default getConfig();
